module.exports = __webpack_public_path__ + "static/turtle_albedo-87a22cb8f18b6e1754d3f38925a0b57f.png";